import { Component, OnInit, inject } from '@angular/core';
import {HydraService} from '../../../core/services/hydra.service';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {ModalCharteDeontologiqueComponent} from '../modal-charte-deontologique/modal-charte-deontologique.component';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {ToolsService} from '../../services/tools/tools.service';
import {TranslationService} from '../../services/translation.service';

import {MatChip, MatChipSet} from '@angular/material/chips';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-modal-info-expert',
    templateUrl: './modal-info-expert.component.html',
    styleUrls: ['./modal-info-expert.component.scss'],
    providers: [TranslationService],
    imports: [MatChip, TranslateModule, MatChipSet, MatDialogTitle, MatDialogContent]
})
export class ModalInfoExpertComponent implements OnInit {
    private hydraService = inject(HydraService);
    dialogRef = inject<MatDialogRef<ModalCharteDeontologiqueComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    auth = inject(AuthentificationService);
    private toolService = inject(ToolsService);
    translationService = inject(TranslationService);

    public infoExpert = null;
    public infoExpertLabo = null;


    ngOnInit() {
        this.getUtilisateur();
    }

    public getUtilisateur() {
        this.hydraService.getById(this.data['@id']).subscribe(res => {
            this.infoExpert = res;
            this.getLabo();
        });
    }

    public getLabo() {
        if (this.infoExpert['laboratoire'] != null) {
            this.hydraService
                .getById(this.infoExpert['laboratoire'])
                .subscribe(res => {
                    this.infoExpertLabo = res;
                });
        }
    }
}
